import { useUIStore } from '@/stores/ui';

interface LogoProps {
  className?: string;
  alt?: string;
  /** Force a variant regardless of app theme (e.g. the white login screen always
   *  wants the light/black-yellow bee). */
  variant?: 'light' | 'dark';
}

/**
 * Theme-aware logo — swaps between logo-light.avif and logo-dark.avif
 * based on the user's theme preference (or an explicit `variant` override).
 */
export function Logo({ className = 'h-8 w-auto', alt = 'B-Mail', variant }: LogoProps) {
  const theme = useUIStore((s) => s.theme);
  const effective = variant || theme;
  const src = effective === 'dark' ? '/logo-dark.avif' : '/logo-light.avif';

  // object-contain: never stretch/distort, whatever box the parent gives it.
  return <img src={src} alt={alt} className={`${className} object-contain`} />;
}